// extracted by mini-css-extract-plugin
export default {"container":"RentAdvert_container__0vbNv","aSide":"RentAdvert_aSide__Qokdo","bSide":"RentAdvert_bSide__tSwY5","headingContainer":"RentAdvert_headingContainer__xTOHk"};